import moment from 'moment-timezone'

export const ALL_YEARS = 'All Years'

export function parseTimeRates(rawValue) {
    if (typeof rawValue !== 'string') {
        throw new Error('Company timeRateInfo must be a string')
    }
    if (rawValue === '') {
        return []
    }
    return rawValue.split('&&').map((entry, index) => {
        const parts = entry.split(':')
        if (parts.length !== 3 || parts[0] === '' || parts[1] === '' || !/^(0|1)$/.test(parts[2])) {
            throw new Error(`Invalid time rate at position ${index + 1}`)
        }
        const rate = Number(parts[1])
        if (!Number.isFinite(rate) || rate < 0) {
            throw new Error(`Invalid time rate amount at position ${index + 1}`)
        }
        return {name: parts[0], rate, showRateName: Number(parts[2])}
    })
}

export function encodeTimeRates(rates) {
    return rates.map(rate => `${rate.name}:${rate.rate}:${rate.showRateName}`).join('&&')
}

export function validateTimePreferences(company) {
    if (typeof company.timeFilterYear !== 'string') {
        throw new Error('Company timeFilterYear must be a string')
    }
    if (![0, 1, 2, 4].includes(company.timeGroupBy)) {
        throw new Error('Company timeGroupBy is invalid')
    }
    if (![0, 1].includes(company.timeSortType)) {
        throw new Error('Company timeSortType is invalid')
    }
    if (![0, 1].includes(company.timeSortAscending)) {
        throw new Error('Company timeSortAscending is invalid')
    }
}

export function makeTimeYearOptions(times) {
    const years = new Set(times.map(time => moment.unix(Number(time.startDate)).format('YYYY')))
    return [ALL_YEARS].concat(Array.from(years).sort((left, right) => Number(right) - Number(left)))
}

export function filterTimes(times, companyUUID, billed, year, keyword) {
    const normalizedKeyword = keyword.trim().toLocaleLowerCase()
    return times.filter(time => {
        if (time.companyUUID !== companyUUID || time.syncStatus === 1 || time.billed !== billed) {
            return false
        }
        if (year !== ALL_YEARS && moment.unix(Number(time.startDate)).format('YYYY') !== year) {
            return false
        }
        if (normalizedKeyword === '') {
            return true
        }
        return time.clientName.toLocaleLowerCase().includes(normalizedKeyword)
            || time.timeDescription.toLocaleLowerCase().includes(normalizedKeyword)
    })
}

export function timeGroupKey(time, groupBy) {
    const date = moment.unix(Number(time.startDate))
    if (groupBy === 0) {
        return date.format('YYYY')
    }
    if (groupBy === 1) {
        return `${date.format('YYYY')} Q${date.quarter()}`
    }
    if (groupBy === 2) {
        return date.format('MMMM YYYY')
    }
    return time.clientName
}

export function sortTimes(times, sortType, ascending) {
    const direction = ascending === 1 ? 1 : -1
    return times.slice().sort((left, right) => {
        if (sortType === 0) {
            const clientOrder = left.clientName.localeCompare(right.clientName)
            if (clientOrder !== 0) {
                return clientOrder * direction
            }
        }
        return (Number(left.startDate) - Number(right.startDate)) * direction
    })
}
